
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'
import {getBounds} from '../../utils/dom/pos.js'
// import Support from '../../utils/global/Support.js'

// const SUPPORT_TOUCH = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)

export default {

    props: {
        focus: { type: Boolean, default: true }
    },

    watch: {
        focus(focus)
        {
            if (this._video)
            {
                if (focus)
                {
                    this._video.play()
                }
                else
                {
                    this._video.pause()
                }
            }
        }
    },

    data()
    {
        return {
            fakeScroll: !this.$root.$children[0].support.touch,
            scrollY: 0,
            touch: this.$root.$children[0].support.touch// Support.touch
            // bookBottomH: 0
        }
    },

    created()
    {
        // EVENTS
        this._onResized = this._onResized.bind(this)
        this._scrollY = this._scrollY.bind(this)
        this._enterFrame = this._enterFrame.bind(this)

        this.eventHub.$on('window:resized', this._onResized)
        // this.eventHub.$on('window:scroll:smooth', this._onScroll)
        this.eventHub.$on('enterFrame', this._enterFrame)

        if (this.fakeScroll)
        {
            // this.eventHub.$on('window:scroll:smooth', this._onScroll)
            this.$root.$children[0].scroll.addOnSmoothScroll(this._scrollY)
        }
        else
        {
            // this.eventHub.$on('window:scroll', this._onScroll)
            this.$root.$children[0].scroll.addOnScroll(this._scrollY)
        }
    },

    mounted()
    {
        // ADD PROPERTIES
        this._contentElmt = this.$el.querySelector('.js-content')
        this._initBottom()

        // this._initBookScroll()


        // INIT DATAS
        this._onResized()
        this._scrollY(0)
        this._onLoaded()
        this._initVideo()
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResized)
        // this.eventHub.$off('window:scroll:smooth', this._onScroll)
        this.eventHub.$off('enterFrame', this._enterFrame)

        if (this.fakeScroll)
        {
            // this.eventHub.$off('window:scroll:smooth', this._onScroll)
            this.$root.$children[0].scroll.removeOnSmoothScroll(this._scrollY)
        }
        else
        {
            // this.eventHub.$off('window:scroll', this._onScroll)
            this.$root.$children[0].scroll.removeOnScroll(this._scrollY)
        }
    },

    methods: {

        _initVideo()
        {
            this._video = this.$el.querySelector('.js-couv')
            if (this._video)
            {
                if (focus)
                {
                    this._video.play()
                }
                else
                {
                    this._video.pause()
                }
            }
        },

        scrollTop()
        {
            this.$root.$children[0].scrollTo(0, 0)
        },

        _onPlayerReady( player )
        {
            this.player = player
        },

        _onResized()
        {
            // GET DOM DATAS
            // this._updateBook()
            this._updateBottom()


            // CHANGE DOM DATAS
            this.$root.$children[0].setHeight( this.fakeScroll ? this._contentElmt.offsetHeight : -1 )
        },

        _enterFrame(dt)
        {

        },

        _scrollY( posY )
        {
            this.scrollY = posY
            // this._moveBook(posY)

            if (this.focus)
            {
                if (this.fakeScroll)
                {
                    this._contentElmt.style.transform = `translateY(-${posY}px) translateZ(0)`
                }

                this._moveBottom(posY)
            }
        },

        _onLoaded()
        {
            this.eventHub.$emit('page:loaded', this)
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       BOOK
                │
                └─────────────────────────────────────────────
        */

        /*_initBookScroll()
        {
            const bottomElmt = this.$el.querySelector('.js-book-bottom')
            const limitElmt = this.$el.querySelector('.js-book-limit')

            this._bookData = {
                bottomElmt,
                limitElmt,
                topElmt: this.$el.querySelector('.js-book-top'),
                limitY: limitElmt.offsetTop,
                height: bottomElmt.offsetHeight,
                pos: 0
            }
        },

        _updateBook()
        {
            const bookBottomHeight = this._bookData.bottomElmt.offsetHeight
            this._bookData.limitY = this._bookData.limitElmt.offsetTop
            this._bookData.height = bookBottomHeight
            this._moveBook(this.scrollY)
        },

        _moveBook( scrollY )
        {
            const root = this.$root.$children[0]
            const data = this._bookData
            const distMax = data.limitY - root.windowSize[1] * 0.5

            let translateY = 0
            if (distMax < 100)
            {
                if (this._bookData.pos === 0)
                {
                    return
                }
            }
            else
            {
                const translateMax = data.height * 0.125
                translateY = Math.min(Math.max(1 - scrollY / distMax, 0), 1)
                translateY = translateY * translateY * translateMax
            }

            const srt = translateY.toFixed(0)
            data.pos = Math.round(translateY)
            data.topElmt.style.transform = `translateY(${srt}px) translateZ(0)`
            data.bottomElmt.style.transform = `translateY(-${srt}px) translateZ(0)`
        },*/


        /*
                ┌─────────────────────────────────────────────
                │
                │       BOTTOM
                │
                └─────────────────────────────────────────────
        */

        _initBottom()
        {
            this._bottomData = {
                textElmt: this.$el.querySelector('.js-nav-bottom'),
                imgElmt: this.$el.querySelector('.js-img-bottom'),
                isOut: true,
                //bounds: { x:0, y:0, w:0, h:0 }
            }
        },

        _updateBottom()
        {
            this._bottomData.bounds = getBounds(this._bottomData.textElmt)
        },

        _moveBottom( scrollY )
        {
            const root = this.$root.$children[0]
            const scrollMax = root.height - root.windowSize[1]
            const dist = scrollMax - scrollY
            const textDist = dist * 0.5
            const imgDist = dist * 0.2

            // console.log( isOut )

            this._bottomData.textElmt.style.transform = `translateY(${textDist}px) translateZ(0)`
            this._bottomData.imgElmt.style.transform = `translateY(${imgDist}px) translateZ(0)`
        },
    }
}
